module.exports = __webpack_public_path__ + "img/2025-07-21b_6.37b852f6.jpg";